export const summonersGet = () => {
  const API_BASE = "https://www.bangingheads.net";
  const url = `/leaderboard.php`;
  return fetch(API_BASE + url).then(response => response.json());
};
